var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"AnalyticsPost","componentProps":_vm.$props,"innerComponentClass":_vm.$style.fixHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }